import classNames from 'classnames';
import { ReactNode, useCallback, useMemo, useRef, useState } from 'react';

import useElementSize from '../../hooks/useElementSize';

import BasicButton from '../buttons/BasicButton';
import AccordionIcon from '../icons/AccordionIcon';

import styles from '../../styles/partials/accordion.module.css';

interface AccordionPanelProps {
    label: ReactNode;
    children: ReactNode;
    className?: string | null;
    buttonClassName?: string | null;
}

function AccordionPanel({ label, children, className, buttonClassName }: AccordionPanelProps) {
    const [opened, setOpened] = useState(false);
    const { ref, height = 0 } = useElementSize();

    const onClick = useCallback(() => {
        setOpened((prev) => !prev);
    }, []);

    return (
        <div
            className={classNames([
                styles.container,
                className,
                {
                    [styles.opened]: opened,
                },
            ])}
        >
            <BasicButton onClick={onClick} className={classNames([styles.button, buttonClassName])}>
                {label}
                <AccordionIcon opened={opened} className={styles.icon} />
            </BasicButton>
            <div className={styles.wrapper} style={{ maxHeight: opened ? height : 0 }}>
                <div className={styles.children} ref={ref}>
                    {children}
                </div>
            </div>
        </div>
    );
}

export default AccordionPanel;
